import {isAnalysisToolBoxPlotEnabled} from 'analysis-tool/AnalysisToolFeatureGates';
import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStep} from 'pipelines/PipelineTypes';

import {STEP_CONFIG_SETTINGS} from './step-config-settings/StepConfigSettings';

export type ConfigEditorStepType = keyof typeof STEP_CONFIG_SETTINGS;

export type ConfigEditorStepTypeVersion<StepType extends ConfigEditorStepType> = number;

export function isConfigEditorStepType(
  stepType: PipelineStepType
): stepType is keyof typeof STEP_CONFIG_SETTINGS {
  return STEP_CONFIG_SETTINGS.hasOwnProperty(stepType);
}

/**
 * Check if a step type can be configured (to edit or to create) using the generic step config editor.
 */
export function stepTypeIsConfigEditorSupported(
  stepType: PipelineStepType,
  stepVersion: number
): stepType is ConfigEditorStepType {
  if (stepType === PipelineStepType.CHART_VIEW) {
    return isAnalysisToolBoxPlotEnabled();
  }
  if (isConfigEditorStepType(stepType)) {
    const settings = STEP_CONFIG_SETTINGS[stepType];
    return stepVersion < settings.length && settings[stepVersion] != null;
  }
  return false;
}

/**
 * Check if a step can be edited using the generic step config editor.
 */
export function stepIsConfigEditorSupported(
  step: PipelineStep
): step is PipelineStep<ConfigEditorStepType, ConfigEditorStepTypeVersion<ConfigEditorStepType>> {
  return stepTypeIsConfigEditorSupported(step.stepType, step.stepVersion);
}
